/* Dr. Zubala custom theme scripts. Vanilla JS, guarded. */
(function () {
  'use strict';
  if (window.__dzInit) return;
  window.__dzInit = true;
  function ready(fn){ if(document.readyState!=='loading'){fn();} else {document.addEventListener('DOMContentLoaded',fn);} }
  function initFaq(){
    document.addEventListener('click', function(e){
      var btn=e.target.closest('.dz-faq__q'); if(!btn) return;
      var expanded=btn.getAttribute('aria-expanded')==='true';
      var panel=document.getElementById(btn.getAttribute('aria-controls'));
      btn.setAttribute('aria-expanded', String(!expanded));
      if(panel){ if(expanded){panel.style.maxHeight=null;} else {panel.style.maxHeight=panel.scrollHeight+'px';} }
    });
    window.addEventListener('resize', function(){
      document.querySelectorAll('.dz-faq__q[aria-expanded="true"]').forEach(function(btn){
        var panel=document.getElementById(btn.getAttribute('aria-controls'));
        if(panel) panel.style.maxHeight=panel.scrollHeight+'px';
      });
    });
  }
  function initQty(){
    document.addEventListener('click', function(e){
      var b=e.target.closest('[data-dz-qty]'); if(!b) return;
      var wrap=b.closest('.dz-qty'); if(!wrap) return;
      var input=wrap.querySelector('input'); if(!input) return;
      var min=parseInt(input.getAttribute('min')||'1',10);
      var val=parseInt(input.value||'1',10); if(isNaN(val)) val=min;
      val = b.getAttribute('data-dz-qty')==='up' ? val+1 : val-1;
      if(val<min) val=min;
      input.value=val;
      input.dispatchEvent(new Event('change',{bubbles:true}));
    });
  }
  function initGallery(){
    document.addEventListener('click', function(e){
      var thumb=e.target.closest('.dz-gallery__thumb'); if(!thumb) return;
      var gallery=thumb.closest('[data-dz-gallery]'); if(!gallery) return;
      var mainImg=gallery.querySelector('.dz-gallery__main img');
      var full=thumb.getAttribute('data-full'); var alt=thumb.getAttribute('data-alt')||'';
      if(mainImg && full){ mainImg.src=full; mainImg.alt=alt; }
      gallery.querySelectorAll('.dz-gallery__thumb').forEach(function(t){t.classList.remove('is-active');});
      thumb.classList.add('is-active');
    });
  }
  function initVariants(){
    document.querySelectorAll('[data-dz-variant-select]').forEach(function(select){
      select.addEventListener('change', function(){
        var opt=select.options[select.selectedIndex];
        var form=select.closest('form'); if(!form) return;
        var idInput=form.querySelector('[data-dz-variant-id]'); if(idInput) idInput.value=select.value;
        var priceEl=document.querySelector('[data-dz-price]'); var price=opt.getAttribute('data-price');
        if(priceEl && price) priceEl.textContent=price;
        var atc=form.querySelector('.dz-buybox__atc'); var available=opt.getAttribute('data-available')==='true';
        if(atc){ atc.disabled=!available; atc.textContent=available?(atc.getAttribute('data-label')||'Add to cart'):'Sold out'; atc.classList.toggle('dz-buybox__soldout',!available); }
      });
    });
  }
  function initUgc(){
    document.addEventListener('click', function(e){
      var tile=e.target.closest('[data-dz-video]'); if(!tile) return;
      var url=tile.getAttribute('data-dz-video'); if(!url) return;
      if(tile.querySelector('video')||tile.querySelector('iframe')) return;
      var isFile=/\.(mp4|webm|mov)(\?|$)/i.test(url); var media;
      if(isFile){ media=document.createElement('video'); media.src=url; media.controls=true; media.autoplay=true; media.playsInline=true; media.setAttribute('style','width:100%;height:100%;object-fit:cover;'); }
      else { media=document.createElement('iframe'); media.src=url+(url.indexOf('?')>-1?'&':'?')+'autoplay=1'; media.setAttribute('allow','autoplay; encrypted-media; picture-in-picture'); media.setAttribute('allowfullscreen',''); media.setAttribute('style','width:100%;height:100%;border:0;'); }
      tile.innerHTML=''; tile.appendChild(media);
    });
  }
  function initStickyAtc(){
    var bar=document.querySelector('[data-dz-sticky-atc]'); if(!bar) return;
    document.documentElement.classList.add('dz-has-sticky-atc');
    var anchor=document.querySelector('[data-dz-buybox-anchor]')||document.querySelector('.dz-product-hero');
    function toggle(){
      if(window.innerWidth>820){ bar.classList.remove('is-visible'); return; }
      var show=true;
      if(anchor){ var r=anchor.getBoundingClientRect(); show=r.bottom<60; }
      bar.classList.toggle('is-visible',show);
    }
    window.addEventListener('scroll',toggle,{passive:true});
    window.addEventListener('resize',toggle);
    toggle();
  }
  function initAnnouncement(){
    document.querySelectorAll('[data-dz-announcement]').forEach(function(bar){
      var msgs=bar.querySelectorAll('.dz-announcement__msg'); if(msgs.length<2) return;
      var interval=parseInt(bar.getAttribute('data-interval')||'5000',10); var i=0;
      setInterval(function(){ msgs[i].classList.remove('is-active'); i=(i+1)%msgs.length; msgs[i].classList.add('is-active'); }, interval);
    });
  }
  ready(function(){ initFaq(); initQty(); initGallery(); initVariants(); initUgc(); initStickyAtc(); initAnnouncement(); });
})();
